module.exports = __webpack_public_path__ + "media/nian_the_cuddle_beast.9d91c5f1.webm";